import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { i18n } from './i18n'
import Dinero from "dinero.js"
import VueAuthenticate from 'vue-authenticate'
import VueMeta from 'vue-meta'

require('@/main.css')

Vue.use(VueMeta)

Vue.use(VueAuthenticate, {
  baseUrl: 'http://admin.test/api/', // Your API domain
  providers: {
    graph: {
      tokenName: 'code',
      tokenPath: 'code',
      authorizationEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
      oauthType: '2.0',
      scope: ['user.read'],
      scopeDelimiter: " ",
      optionalUrlParams: ["scope"],
      clientId: '783317d4-0f65-40ce-ab94-84272b7e8076',
      redirectUri: process.env.VUE_APP_GRAPH_CALLBACK_URL // Your client app URL
    }
  }
})

Vue.config.productionTip = false

import './validation'

import './filters'

import VueAxios from 'vue-axios'
import axios from 'axios'

axios.defaults.headers.common['X-App-Locale'] = i18n.locale
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'

Vue.use(VueAxios, axios)
// If response is unauthenticated or csrf token expired redirect to Login page
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if ((error.response?.status === 401 || error.response?.status === 419) && router.currentRoute?.name && router.currentRoute.name !== 'Login') {
    router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
  } else if (error.response?.status === 403) {
    if (store.state.auth.user.is_demo) {
      store.dispatch('snackbar/show', { color: 'warning', text: i18n.t('Your demo account does not allow you to do this action') })
      return Promise.resolve()
    } else {
      store.dispatch('snackbar/show', { color: 'error', text: i18n.t('You are not allowed to do this action') })
    }
  }

  return Promise.reject(error)
})

Vue.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

Dinero.defaultCurrency = 'EUR'
Dinero.globalLocale = i18n.locale

const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

if (window.Cypress) {
  // only available during E2E tests
  window.app = app
}
